import cloneDeep from 'lodash/fp/cloneDeep'
import { START_EDITING_PENDING_APPROVAL_BLURB
  , STOP_EDITING_PENDING_APPROVAL_BLURB
  , CANCEL_EDITING_PENDING_APPROVAL_BLURB
  , SET_PENDING_APPROVAL_BLURB_ADVISER_FIRST_NAME
  , SET_PENDING_APPROVAL_BLURB_ADVISER_MIDDLE_NAME
  , SET_PENDING_APPROVAL_BLURB_ADVISER_LAST_NAME
  , SET_PENDING_APPROVAL_BLURB_ADVISER_TITLE
  , SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY
  , SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY_WEBSITE
  , SET_PENDING_APPROVAL_BLURB_ADVISER_BUILDING_DETAILS
  , SET_PENDING_APPROVAL_BLURB_ADVISER_STREET_ADDRESS
  , SET_PENDING_APPROVAL_BLURB_ADVISER_SUBURB
  , SET_PENDING_APPROVAL_BLURB_ADVISER_POSTAL_CODE
  , SET_PENDING_APPROVAL_BLURB_ADVISER_CITY
  , SET_PENDING_APPROVAL_BLURB_ADVISER_DESCRIPTION
} from './pendingApprovalAdviserProfileBlurbEditorActions'
import { validiateTextField } from '../../../../../common/forms/validationFunctions'

const initialState = {
  loadingBlurb: false,
  editingBlurb: false,
  beforeEditingState: {},
  isInvalid: {
    formIsValid: true,
    firstName: {
      isInvalid: false,
      message: null
    },
    middleName: {
      isInvalid: false,
      message: null
    },
    lastName: {
      isInvalid: false,
      message: null
    },
    title: {
      isInvalid: false,
      message: null
    },
    company: {
      isInvalid: false, // 'error'
      message: null // msg
    },
    companyWebsite: {
      isInvalid: false,
      message: null
    },
    buildingDetails: {
      isInvalid: false,
      message: null
    },
    streetAddress: {
      isInvalid: false,
      message: null
    },
    suburb: {
      isInvalid: false,
      message: null
    },
    postalCode: {
      isInvalid: false,
      message: null
    },
    city: {
      isInvalid: false,
      message: null
    },
    businessDescription: {
      isInvalid: false,
      message: null
    }
  }
}

export default function (state = initialState, action) {
  function copyBlurbState (state) {
    var blurb = cloneDeep(state.blurb)
    blurb.isInvalid = cloneDeep(state.blurb.isInvalid)
    return blurb
  }

  function formIsValid (isInvalid) {
    // validiateTextField returns a boolean `isInvalid` (not the legacy BS3 'error' string),
    // so gate on the boolean - otherwise required fields never block Save.
    return !isInvalid.title.isInvalid &&
      !isInvalid.company.isInvalid &&
      !isInvalid.buildingDetails.isInvalid &&
      !isInvalid.streetAddress.isInvalid &&
      !isInvalid.suburb.isInvalid &&
      !isInvalid.postalCode.isInvalid &&
      !isInvalid.city.isInvalid &&
      !isInvalid.companyWebsite.isInvalid &&
      !isInvalid.businessDescription.isInvalid &&
      !isInvalid.firstName.isInvalid &&
      !isInvalid.middleName.isInvalid &&
      !isInvalid.lastName.isInvalid
  }

  // not going to copy all the state over because we're using reducer composition.
  // just copying the pieces i want to work with
  switch (action.type) {
    case START_EDITING_PENDING_APPROVAL_BLURB:
      state.blurb = copyBlurbState(state)
      state.blurb.editingBlurb = true
      state.beforeEditingState = state.profile
      return state
    case STOP_EDITING_PENDING_APPROVAL_BLURB:
      state.blurb = copyBlurbState(state)
      state.blurb.editingBlurb = false
      return state
    case CANCEL_EDITING_PENDING_APPROVAL_BLURB:
      state.blurb = copyBlurbState(state)
      state.blurb.editingBlurb = false
      state.profile = cloneDeep(state.beforeEditingState)
      state.beforeEditingState = {}
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_FIRST_NAME:
      state.pendingApprovalProfile.firstName = action.firstName
      state.pendingApprovalProfile.adviserName = state.pendingApprovalProfile.firstName + ' ' + state.pendingApprovalProfile.lastName
      state.blurb.isInvalid.firstName = validiateTextField(action.firstName, 63, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_MIDDLE_NAME:
      state.pendingApprovalProfile.middleName = action.middleName
      state.blurb.isInvalid.middleName = validiateTextField(action.middleName, 63, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_LAST_NAME:
      state.pendingApprovalProfile.lastName = action.lastName
      state.pendingApprovalProfile.adviserName = state.pendingApprovalProfile.firstName + ' ' + state.pendingApprovalProfile.lastName
      state.blurb.isInvalid.lastName = validiateTextField(action.lastName, 63, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_TITLE:
      state.pendingApprovalProfile.title = action.title
      state.blurb.isInvalid.title = validiateTextField(action.title, 127, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY:
      state.pendingApprovalProfile.company = action.company
      state.blurb.isInvalid.company = validiateTextField(action.company, 127, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_COMPANY_WEBSITE:
      state.pendingApprovalProfile.companyWebsite = action.website
      state.blurb.isInvalid.companyWebsite = validiateTextField(action.website, 2047, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_BUILDING_DETAILS:
      state.pendingApprovalProfile.buildingDetails = action.buildingDetails
      state.blurb.isInvalid.buildingDetails = validiateTextField(action.buildingDetails, 255, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_STREET_ADDRESS:
      state.pendingApprovalProfile.streetAddress = action.streetAddress
      state.blurb.isInvalid.streetAddress = validiateTextField(action.streetAddress, 255, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_SUBURB:
      state.pendingApprovalProfile.suburb = action.suburb
      state.blurb.isInvalid.suburb = validiateTextField(action.suburb, 255, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_POSTAL_CODE:
      state.pendingApprovalProfile.postalCode = action.postalCode
      state.blurb.isInvalid.postalCode = validiateTextField(action.postalCode, 10, false)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_CITY:
      state.pendingApprovalProfile.city = action.city
      state.blurb.isInvalid.city = validiateTextField(action.city, 255, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
    case SET_PENDING_APPROVAL_BLURB_ADVISER_DESCRIPTION:
      state.pendingApprovalProfile.blurb = action.adviserDescription
      state.blurb.isInvalid.businessDescription = validiateTextField(action.adviserDescription, Infinity, true)
      state.blurb.isInvalid.formIsValid = formIsValid(state.blurb.isInvalid)
      state.edited = true
      return state
  }
  return state
}
